import { render, staticRenderFns } from "./HeaderBackground.vue?vue&type=template&id=0c33e46f&scoped=true"
import script from "./HeaderBackground.vue?vue&type=script&lang=ts"
export * from "./HeaderBackground.vue?vue&type=script&lang=ts"
import style0 from "./HeaderBackground.vue?vue&type=style&index=0&id=0c33e46f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c33e46f",
  null
  
)

export default component.exports